import React from "react";
import {
  Button,
  UncontrolledDropdown,
  DropdownToggle
} from "reactstrap";
import {connect} from "react-redux";
import { history } from "@src/history"
import {getUserIcon} from '@store/actions/socket/socket_actions';
import Ripples from 'react-ripples' 
import "./custom.scss";
import { withUAL } from 'ual-reactjs-renderer'
import TooltipLinkWax from '@components/tooltip/TooltipLinkWax';
import TooltipControlled from '@components/tooltip/TooltipControlled';
import { OreId} from "oreid-js";
import { WebPopup } from "oreid-webpopup";
import LoginModal from '@views/pages/modals/LoginModal';
import UserDropdown from "./UserDropdown"

const handleNavigation = (e, path) => {
  e.preventDefault();
  history.push(path, { from: history.location.pathname })
}
var userData;
const oreIdOptions = {
  appName: "ORE ID Login",
  appId: process.env.REACT_APP_OREID_APP_ID,
  plugins: { popup: WebPopup() }
}
var oreId = new OreId(oreIdOptions);
oreId.init()
class NavbarUser extends React.PureComponent {
  state = {
      showSelectLogin:false,
      withdrawal_res_id: false,
      showModal: false
  }
  userLoggedIn = true
  componentDidMount = async() => {
    this.props.getUserIcon();
  }
  componentDidUpdate = async(prevProps) => {}
    
  selectLoginPlatform = () => {
    this.setState({showSelectLogin:true});
  }
  render() {
    let accountName = this.props.user?.userAccount;
    return (
      <ul className="nav navbar-nav navbar-nav-user float-right align-items-center flex-row">
        <UncontrolledDropdown isOpen={this.state.showNewsList} tag="li" className="dropdown-user nav-item" toggle={(e)=>{
            console.log('toggle')
            this.setState({showNewsList: !this.state.showNewsList})

        }}>
          <DropdownToggle tag="a" className="nav-link dropdown-news-link" onClick={()=>{
              this.setState({showNewsList: true})
          }}>
            <div className="user-nav">
                <a className="user-name-link" href="#" onClick={e => handleNavigation(e, "/news")} target="_blank" rel="noopener noreferrer">
                    {this.props.news_events === 0 && <img src={'/img/News.svg'} />}
                    {this.props.news_events > 0 && <img src={'/img/News_with_dot.svg'} />}
                </a>
            </div>
          </DropdownToggle>
        </UncontrolledDropdown>     
        <UncontrolledDropdown tag="li" className="dropdown-user nav-item">
          <DropdownToggle tag="div" className={`nav-link dropdown-user-link ${accountName && 'authorized' }`}>
            <div className="user-nav">
              <TooltipLinkWax id={`img_`} placement='top' text={
                <span className="user-name m-0">
                <a className="user-name-link" href={`https://wax.bloks.io/account/${accountName}`} target="_blank" rel="noopener noreferrer">{accountName}</a>
               </span>}
                tooltip={"Open your wax wallet over  on wax.blocks.io in a new tab."} />
              <span className="user-status">{''}</span>
            </div>
            <span data-tour="user">
                {!accountName && <Ripples>
                    <Button className="new-btn btn-main new-btn-sm btn-login" type="button" 
                        onClick={(e) => {
                          e.preventDefault();
                          this.setState({showModal: true})
                        }}>
                      Login
                    </Button>
                </Ripples>}

              {accountName && 
              <div className="wrapper-avatar">
                {(!this.props.user_icon || this.props.user_icon == "default.svg") && <img
                  src={this.props.user?.photoUrl ? this.props.user?.photoUrl : '/img/avatars/default.svg' }
                  className="round"
                  height="40"
                  width="40"
                  alt="avatar"
                />}
                {this.props.user_icon != null && this.props.user_icon != 0 && this.props.user_icon !== "default.svg" && <img
                  src={"/img/avatars/"+this.props.user_icon}
                  className="round"
                  height="40"
                  width="40"
                  alt="avatar"
                />}
                  <TooltipControlled id={`img_rank`} placement='top' text={
                  <svg className="round-rank" height="40" width="40">
                    <use href={`/img/ranks-logo-sprite.svg?v=1#${this.props?.user_rank?.id}`}/>
                  </svg>}
                  tooltip={this.props?.user_rank?.name}
                  />
              </div>
              }
            </span>
          </DropdownToggle>
          {accountName && <UserDropdown {...this.props} />}
        </UncontrolledDropdown>
        {this.state.showModal && <LoginModal closeModal={()=>{console.log('closeModal');this.setState({showModal:false})}}/>}
      </ul>
    )
  }
}

const mapStateToProps = state => {
  return {
    user: state.authorizedUser.user,
    wax: state.authorizedUser.wax,
    socket: state.socket.socket,
    socket_user: state.socket.socket_user,
    socket_connected: state.socket.socket_connected,
    got_nft_list:state.nft.got_nft_list,
    news_events:state.socket.news_events,
    user_icon: state.socket.user_icon,
    user_rank:state.socket.user_rank,
  }
}

export default withUAL(connect(mapStateToProps, {getUserIcon})(NavbarUser))
